import { gql } from 'apollo-boost'


export const TRIAL_PERIOD = gql`
query($email: String){
  trialPeriod(email: $email)
}
`

